import { createContext } from 'react';
import { UsuarioConfigs } from '../types/usuario_config';

interface MyContextType {
  state: UsuarioConfigs;
  setState: (value: UsuarioConfigs) => void;
}

const MyContext = createContext<MyContextType | undefined>(undefined);

export default MyContext;
